module.exports = __webpack_public_path__ + "img/avatar-bg-3rd1.c8f9cd6b.png";